import { Form, Button, Container, Row, Col } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

function PhoneAuth(props) {
  const { isCorrectCode } = props;
  const MySwal = withReactContent(Swal);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (localStorage.getItem("isLoggedIn") === "true") {
      isCorrectCode(true);
    }
  }, [isCorrectCode]);

  const handleLogin = async () => {
    MySwal.fire({
      title: (
        <div>
          <h3 style={{ color: "blue" }}>جاري التحقق من الدخول</h3>
        </div>
      ),
      didOpen: () => {
        MySwal.showLoading();
      },
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/login`,
        {
          username,
          password,
        },
      );

      if (response.data.success) {
        localStorage.setItem("isLoggedIn", "true");
        isCorrectCode(true);
        MySwal.close();
      }
    } catch (error) {
      isCorrectCode(false);
      MySwal.fire(
        <div>
          <h1 style={{ color: "red" }}>فشل الدخول</h1>
          <p>اسم المستخدم او كلمة المرور غير صحيحة</p>
        </div>,
      );
    }
  };

  return (
    <Container style={{ marginTop: 50 }}>
      <Row className="justify-content-center">
        <Col xs={9} sm={7} md={5}>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicUsername">
              <Form.Control
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Username"
                value={username}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="Password"
                value={password}
              />
            </Form.Group>

            <Button onClick={handleLogin} variant="success">
              Login
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default PhoneAuth;
